<template>
  <div class="tc-box" v-if="show" @click="show = false">
  	<div class="tc-box-model" @click.stop>
  		<div class="tc-box-model-top">
  			<div class="tc-box-model-top-div"></div>
  			<div class="tc-box-model-top-title">{{$t('all.tishi')}}</div>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="tc-box-model-center">{{$t('all.shifouquedingjieshuzhibo')}}</div>
		<div class="tc-box-model-bottom" @click="closeChatRoom">{{$t('all.queding')}}</div>
  	</div>
  </div>
</template>

<script>
import { closeChatRoom } from "@/api/zhibo";
export default {
  data() {
    return {
	  show:false,
    };
  },
  mounted() {
	
  },
  methods: {
	showModel(){
		this.show = true
	},
	//关闭直播间
	async closeChatRoom(){
		const res = await closeChatRoom({liveId:this.$route.query.liveId})
		this.$message({ message: this.$t('all.caozuochenggong'),type: 'success'});
		this.$router.replace({ path: '/shouye' });
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./guanbizhibo.css";
</style>


// WEBPACK FOOTER //
// guanbizhibo.vue?695bda22